import React, { useState } from 'react';
import Heading from '../../components/Heading';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import ReportingForm from 'src/pages/Reporting/ReportingForm';
import TabSwitch, { TabSwitchTab } from 'src/components/TabSwitch/TabSwitch';
import NewBadge from 'src/components/NewBadge/NewBadge';
import { LLMContainer } from 'src/components/LLM/LLMContainer';
import './Reporting.scss';

const REPORTS_TAB_ID = 'reports';
const INSIGHTS_TAB_ID = 'insights';

const REPORTING_TABS: TabSwitchTab[] = [
  { id: REPORTS_TAB_ID, label: 'Reports' },
  {
    id: INSIGHTS_TAB_ID,
    label: 'Juniper Insights Bot',
    badge: <NewBadge spaced beta />,
  },
];

const Reporting = () => {
  const [activeTabId, setActiveTabId] = useState<string>(REPORTS_TAB_ID);

  const isReportsTab: boolean = activeTabId === REPORTS_TAB_ID;

  return (
    <WithNavigation
      title="Reporting"
      top={<Heading headline="Reporting" />}
      bottom={
        <div className="reporting">
          <div className="reporting-tabs">
            <TabSwitch
              tabs={REPORTING_TABS}
              activeTabId={activeTabId}
              onTabChange={(id: string) => setActiveTabId(id)}
            />
          </div>

          {isReportsTab ? (
            <ReportingForm />
          ) : (
            <div className="reporting-insights">
              <LLMContainer />
            </div>
          )}
        </div>
      }
    />
  );
};

export default Reporting;
